import { Box, Flex, Grid } from '@mantine/core';
import { FC } from 'react';
import { ColorPicker } from 'src/components/Form/ColorPicker';
import { InputFile } from 'src/components/Form/File';
import { InputText } from 'src/components/Form/Text';
import { PageLoader } from 'src/components/PageLoader';
import { PageTitle } from 'src/components/PageTitle';
import { Form } from 'src/form';
import { ActionFooter } from 'src/components/ActionFooter';
import { useAddBranding } from './use-add-branding';

export const AddBranding: FC = () => {
  const { isPending, onSubmit, onCancel, initialValues, validate } =
    useAddBranding();

  return (
    <Form initialValues={initialValues} onSubmit={onSubmit} validate={validate}>
      <Flex
        direction="column"
        justify="space-between"
        style={{ height: '100%' }}
      >
        <Box>
          <PageTitle title="Add Branding" />
          <PageLoader visible={isPending} />
          <Grid>
            <Grid.Col span={6}>
              <InputText name="name" label="Name" placeholder="Name" />
            </Grid.Col>

            <Grid.Col span={6} />

            <Grid.Col span={6}>
              <Grid gutter={20}>
                <Grid.Col span={4}>
                  <ColorPicker label="Main Color" name="color_1" />
                </Grid.Col>
                <Grid.Col span={4}>
                  <ColorPicker label="Secondary Color" name="color_2" />
                </Grid.Col>
                <Grid.Col span={4}>
                  <ColorPicker label="Tertiary Color" name="color_3" />
                </Grid.Col>
              </Grid>

              <Grid gutter={20}>
                <Grid.Col span={4}>
                  <InputFile width="100%" label="Main Logo" name="main_logo" />
                </Grid.Col>
                <Grid.Col span={4}>
                  <InputFile
                    width="100%"
                    label="Main Logo"
                    name="secondary_logo"
                  />
                </Grid.Col>
                <Grid.Col span={4}>
                  <InputFile
                    width="100%"
                    label="Tertiary Logo"
                    name="tertiary_logo"
                  />
                </Grid.Col>
              </Grid>
            </Grid.Col>
          </Grid>
        </Box>

        <ActionFooter
          onCancel={onCancel}
          submitButton="CREATE"
          isLoading={isPending}
        />
      </Flex>
    </Form>
  );
};
